import { Box, Paper, Skeleton } from "@mui/material";
import PropTypes from "prop-types";

const TransferListLoading = ({ isNavbarOpen }) => {
  const paperStyles = {
    boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2) !important",
    maxWidth: isNavbarOpen ? "43rem" : "47rem",
    width: "100%",
    height: 230,
    p: 2,
  };

  const renderSkeletonPanel = (panelSide) => (
    <Paper sx={paperStyles}>
      <Skeleton variant="text" width="60%" height={40} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" width="100%" height={20} sx={{ mb: 1 }} />
      {["row1", "row2", "row3", "row4"].map((rowId) => (
        <Skeleton
          key={`skeleton-${panelSide}-${rowId}`}
          variant="rectangular"
          width="100%"
          height={10}
          sx={{ mb: 3 }}
        />
      ))}
    </Paper>
  );

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      {renderSkeletonPanel("left")}

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="circular" width={40} height={40} />
      </Box>

      {renderSkeletonPanel("right")}
    </Box>
  );
};

export default TransferListLoading;

TransferListLoading.propTypes = {
  isNavbarOpen: PropTypes.bool,
};
